import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import type { FormEvent } from 'react';

const navItems = [
  { label: '首页', to: '/' },
  { label: '影视分类', to: '/category' },
  { label: '汉字解析', to: '/special/hanzi-explanation' },
  { label: '剧情介绍', to: '/special/plot-introduction' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
    setMobileOpen(false);
  };

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8 h-16 md:h-[68px] flex items-center gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
            邻
          </span>
          <span className="font-heading font-bold text-base md:text-lg text-foreground-950 tracking-tight whitespace-nowrap">
            隔壁女孩中汉字
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 ml-4">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-3 py-2 rounded-md text-sm font-label transition-colors whitespace-nowrap ${
                isActive(item.to)
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="hidden md:flex items-center gap-2 ml-auto bg-background-100 border border-background-200 rounded-full pl-4 pr-1 py-1 max-w-xs w-full"
        >
          <i className="ri-search-line text-foreground-400 text-base w-4 h-4 flex items-center justify-center"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影视 / 汉字解析 / 剧情"
            className="flex-1 bg-transparent text-sm font-label text-foreground-950 placeholder:text-foreground-400 outline-none min-w-0"
          />
          <button
            type="submit"
            className="shrink-0 px-3 py-1.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-label whitespace-nowrap transition-colors cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="lg:hidden ml-auto md:ml-0 w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <form onSubmit={handleSearch} className="flex md:hidden items-center gap-2 mt-3 bg-background-100 border border-background-200 rounded-full pl-4 pr-1 py-1">
            <i className="ri-search-line text-foreground-400 text-base w-4 h-4 flex items-center justify-center"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 汉字解析 / 剧情"
              className="flex-1 bg-transparent text-sm font-label outline-none min-w-0"
            />
            <button type="submit" className="shrink-0 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-label whitespace-nowrap cursor-pointer">
              搜索
            </button>
          </form>
          <nav className="flex flex-col mt-2">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={`px-3 py-3 rounded-md text-sm font-label ${
                  isActive(item.to) ? 'text-primary-600 bg-primary-50' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}